export const formatDecimalWithComma = (value) => {
  if (value === null || value === undefined || value === "") return "";

  const number = Number(value);

  if (isNaN(number)) return "";

  return number.toFixed(2).replace(".", ",");
};
